
























import { Component, Prop, Vue } from "vue-property-decorator";
import { LineItem } from "@/models/order/order";
import { multiplierWarning } from "@/models/order/quote_notes";

/**
 * FUPOF-191: read-only surface for the derived multiplier warning. The text is
 * computed from the cart rather than stored (see `quote_notes.ts`), so this
 * renders nothing at all while the quote is on a single multiplier and needs no
 * dismissing when a resolution puts it back to one.
 *
 * The warning now rides in the Quote Summary rather than the notes sections, so
 * it carries a link back to the cart — the one screen where the per-line
 * multipliers can actually be changed. The link is suppressed when the summary
 * is already being shown on the cart (nowhere to go).
 */
@Component
export default class MultiplierWarning extends Vue {
  @Prop({ default: () => [] }) items!: LineItem[];
  @Prop({ default: false }) showEditLink!: boolean;

  get warning(): string {
    return multiplierWarning(this.items ?? []);
  }
}
